import CandidatesFilters from './CandidatesFilters.component';

export default CandidatesFilters;
